// Accordions
const accordions = $('.dwyw__category');

accordions.each(function (ii) {
  const accordion = $(this);
  accordion.find('h3').click(function () {
    accordions.stop(true, true).find('.dwyw__category__content-wrap').stop(true, true);

    const isMobile = $('#is-lt-medium').is(':visible');

    // find other accordions that are open
    const openAccordions = accordions.not(accordion).not('.closed').addClass('closed').find('.dwyw__category__content-wrap');

    const text = $(this).next('.dwyw__category__content-wrap');
    if (accordion.hasClass('closed')) {
      accordion.removeClass('closed');

      if (isMobile) {
        // start of first accordion
        let scrollTo = accordions.eq(0).offset().top;
        // add height of collapsed accordion (height of h2 + margin bottom of accordion) times number of accordions before
        scrollTo += (+accordions.eq(0).css('margin-bottom').replace('px', '') + $(this).outerHeight(true)) * ii;
        $('html, body').animate({ scrollTop: `${scrollTo}px` }, 'slow');

        openAccordions.slideUp('slow');
        text.slideDown('slow');
      } else {
        // position open accordion absolutely so we can crossfade closing this one and opening the other
        openAccordions.css({ position: 'absolute', top: `${openAccordions.position().top}px`, left: '0', right: '0' }).fadeOut('slow', function () {
          openAccordions.css({ position: '', top: '', left: '', right: '' });
          openAccordions.slideUp(0);
        });
        // open and fade out this section so we can crossfade it in
        text.slideDown(0, function () {
          const h = openAccordions.outerHeight();
          const h2 = text.outerHeight();
          text.fadeOut({
            duration: 0,
            queue: false,
            complete: function () {
              text.css('height', `${h}px`);
              // animate the height from what the previous one was to what this one should be
              // to prevent jarring page jump
              text.fadeIn({ duration: 'slow', queue: false }).animate({ height: `${h2}px` }, 'slow', function () {
                text.css('height', '');
              });
            }
          });
        });
      }
    } else {
      // only allow closing the open (i.e. all section) on mobile
      if (isMobile) {
        accordion.addClass('closed');
        openAccordions.slideUp('slow');
        text.slideUp('slow');
      }
    }
  });
});

// onchange from mobile to desktop make sure at least 1 is open
$(window).resize(function () {
  if (!$('#is-lt-medium').is(':visible') && accordions.not('.closed').length === 0) {
    accordions.eq(0).removeClass('closed').find('.dwyw__category__content-wrap').show();
  }
});

accordions.slice(1).addClass('closed').find('.dwyw__category__content-wrap').slideUp(0);

let isTouch = false;
let isTouchTimer;
let curRootClass = '';

function addtouchclass (e) {
  clearTimeout(isTouchTimer);
  isTouch = true;
  if (curRootClass !== 'touch-input') {
    curRootClass = 'touch-input';
    document.documentElement.classList.add(curRootClass);
  }
  isTouchTimer = setTimeout(function () { isTouch = false; }, 500); // maintain "istouch" state for 500ms so removetouchclass doesn't get fired immediately following a touch event
}

function removetouchclass (e) {
  if (!isTouch && curRootClass === 'touch-input') {
    isTouch = false;
    curRootClass = '';
    document.documentElement.classList.remove('touch-input');
  }
}

document.addEventListener('touchstart', addtouchclass, false);
document.addEventListener('mouseover', removetouchclass, false);
